import React from 'react'
import { ChargingStateType, VehicleChargingState } from '../../types'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Typography } from '@mui/material'
import { G1Nowifi, J1ToprightarrowC, J2Caution, J2Multiply, J2Update } from '@e3dc-react/icons'

interface Props {
  vehicleAvailable: boolean
  isOnline: boolean
  chargingState?: ChargingStateType
  isVehicleConnectionInProgress: boolean
  isVehicleDisconnected: boolean
}

/**
 * Component for vehicle tile status part to display different states for vehicle available, online and charging states
 */
const VehicleStatus: React.FC<Props> = ({ vehicleAvailable, isOnline, chargingState, isVehicleConnectionInProgress, isVehicleDisconnected }) => {
  const { t } = useCustomTranslation()
  const showChargingError = vehicleAvailable && !isVehicleDisconnected && isOnline && chargingState === VehicleChargingState.fault

  if (isVehicleConnectionInProgress) {
    return (
      <Box display="flex" alignItems="center" sx={{ marginTop: '3px' }}>
        <Typography variant="body2">{t('emobility.vehicle-integration.data.status.connection-in-progress')}</Typography>
        <J2Update style={{ width: '18px', height: '18px', marginLeft: '3px' }}></J2Update>
      </Box>
    )
  }

  if (showChargingError) {
    return (
      <>
        <Typography variant="body2">{t(`emobility.vehicle-integration.data.status.charging-error`)}</Typography>
        <J2Caution sx={{ height: '18px', width: '18px', marginLeft: '3px' }} />
      </>
    )
  }

  if (vehicleAvailable && !isVehicleDisconnected) {
    return (
      <>
        <Typography variant="body2">
          {isOnline && chargingState
            ? t(`emobility.vehicle-integration.data.status.${chargingState.toLowerCase()}`)
            : t(`emobility.vehicle-integration.data.status.offline`)}
        </Typography>
        {isOnline ? <J1ToprightarrowC /> : <G1Nowifi />}
      </>
    )
  }

  return (
    <>
      <Typography variant="body2">{t('emobility.vehicle-integration.data.status.not-available')}</Typography>
      <J2Multiply />
    </>
  )
}

export default VehicleStatus
